<template>
  <div id="app">
    <audio ref="psNotificationSound" preload="auto">
      <source
        src="https://actions.google.com/sounds/v1/alarms/alarm_clock.ogg"
        type="audio/ogg"
      >
    </audio>
    <!-- World Headbar versione SPA -->
    <world-headbar @openWorldMenu="worldMenuOpen = !worldMenuOpen" :theme="'spiagge'" :customProfileUrl="spiaggeDomain + '/impostazioni/'" />
    <vue-progress-bar></vue-progress-bar>
    <!-- Menu laterale di navigazione -->
    <world-menu v-if="!checkingLogin" :menu-open="worldMenuOpen" :menuTheme="'spiagge'" />
    <!-- Link refresh app -->
    <wg-modal v-if="showRefreshPopup" :portal="true" @closeModal="showRefreshPopup = false">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Update available. Please refresh the page.', 'Aggiornamento disponibile. Ricaricare la pagina.') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              class="small com-anm22-button-blue" 
              :value="$anm22.strLang(lang, 'Refresh', 'Ricarica')" 
              @click="pageReload">
        </div>
      </div>
    </wg-modal>
    <!-- PIN REQUEST MODAL - da usare in tutta l'app -->
    <pin-request></pin-request>
    <!-- Router View, contenitore per il rendering dei componenti in fase di navigazione -->
    <div class="com-anm22-app-outer-wrapper" @click="'void(0);'" :style="$route.path === '/login' ? 'padding-left:0;' : ''">
      <div v-if="checkingLogin" class="wg-row" style="justify-content:center;">
        <div class="vertical-height-div" style="height:40px;"></div>
        <div style="font-size:21px;">
          {{ $anm22.strLang(lang, "Logging in...", "Accesso in corso...") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <vue-simple-spinner size="medium" :line-fg-color="appColor" />
      </div>
      <router-view v-else></router-view>
    </div>
    <footer 
        v-if="!userLogged && $route.path === '/login'"
        style="position:fixed; left:0; bottom:0; border-top: 1px #efefef solid; background-color:#FFF; z-index:1000; width:100%;">
      <div style="font-size:14px; color:#999; padding:5px 20px;">
        Spiagge.it - <a href="https://www.spiagge.it/privacy-policy/" style="color:#666;">Privacy Policy</a> - <a href="https://wwww.spiagge.it/cookies/" style="color:#666;">Cookie Policy</a>
      </div>
    </footer>
    <portal-target name="anm22-portal-modal" multiple>
      <!--
      Destinazione per il render dei modali
      -->
    </portal-target>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WorldHeadbar from "../../../world/spa/components/WorldHeadbar.vue";
import WorldMenu from "../../../world/spa/components/WorldMenu.vue";
import { PortalTarget } from 'portal-vue';
import PinRequest from "./components/PinRequest.vue";
import Spinner from "vue-simple-spinner";

export default {
  data() {
    return {
      worldMenuOpen: false,
      showRefreshPopup: false,
      printInterval: null,
      audioEnabled: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      checkingLogin: state => state.auth.checkingLogin,
      userLogged: state => state.auth.userLogged,
      licenseSelected: state => state.licenseSelected,
      isOffline: state => state.offline.isOffline,
      isPrinterMaster: state => state.isPrinterMaster,
      appColor: state => state.config.appColor,
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    hasYbLicenses() {
      return !!this.$store.getters['ybLicenses/getByLicense'](this.license.id).length;
    },
    work() {
      if(this.license) {
        return this.$store.getters['works/get'](this.license.work);
      }
    },
    employment() {
      if(this.userLogged && this.license) {
        return this.$store.getters["foodEmployments/get"](
          this.license.id + "-" + this.user.idWorldUser
        );
      } else {
        return null;
      }
    },
    accessControl() {
      if(this.employment) {
        const permission = this.employment.permission;
        return this.$store.getters["foodAcs/get"](
          this.license.id + "-" + permission
        );
      } else {
        return null;
      }
    },
    /**
     * if no login
     * then
     *   only anm22 logo
     * else
     *  if customer
     *  then
     *    if license
     *    then
     *      [work, history, settings, help]
     *    else
     *      [history, settings, help]
     *  else
     *    if license
     *    then
     *      [...]
     *    else
     *      [settings, help]
     */
    foodMenu() {
      if(!this.userLogged) {
        return [];
      }
      const views = {
        items: []
      };
      const apps = {
        items: []
      };
      const settings = {
        items: [
          {
            name: "settings",
            external: false,
            icon: this.$anm22.icons.getWorldIcon('menuSettings'),
            description: this.$anm22.strLang(this.lang, 'Settings', 'Impostazioni'),
            href: '/settings',
            selectId: "settings"
          },
          {
            name: "help",
            external: false,
            icon: this.$anm22.icons.getWorldIcon('menuHelp'),
            description: this.$anm22.strLang(this.lang, 'Help', 'Aiuto'),
            href: '/help',
            selectId: "help"
          },
          {
            name: "logout",
            external: false,
            icon: this.$anm22.icons.getWorldIcon('menuLogin'),
            description: this.$anm22.strLang(this.lang, 'Logout', 'Esci'),
            href: "/logout",
            selectId: "logout"
          },
        ]
      };
      // employee setup
      if(!this.employment) {
        if(this.license) {
          if(this.license.config.modules.delivery.enabled) {
            views.items.push({
              name: "order",
              external: false,
              icon: this.$anm22.icons.getWorldIcon('menuCart'),
              description: this.$anm22.strLang(this.lang, 'Place new order', 'Crea un nuovo ordine'),
              href: '/order',
              selectId: "order"
            });
          } else {
            views.items.push({
              name: "menu",
              external: false,
              icon: this.$anm22.icons.getWorldIcon('menuMenu'),
              description: this.$anm22.strLang(this.lang, 'View menu', 'Vedi menu'),
              href: '/menu',
              selectId: "menu"
            });
          }
        }
        views.items.push({
          name: "history",
          external: false,
          icon: this.$anm22.icons.getWorldIcon('menuTable'),
          iconHover: this.$anm22.icons.getWorldIcon('menuTableGreen'),
          description: this.$anm22.strLang(this.lang, 'Order history', 'Cronologia ordini'),
          href: '/history',
          selectId: "history"
        });
        return [views, settings];
      } else {
        settings.items.splice(1, 0,
          {
            name: "switch",
            external: false,
            icon: this.$anm22.icons.getWorldIcon('menuSwitch'),
            description: this.$anm22.strLang(this.lang, 'Change restaurant', 'Selezione ristorante'),
            href: "/restaurants",
            selectId: "restaurants"
          }
        );
        if(this.license) {
          /**
           * Il menu è composto dalle seguenti voci (tra parentesi i moduli necessari per attivare l'opzione)
           * - Cassa rapida (fastCash)
           * - Lista ordini (fastCash)
           * - Tavoli (tables) / comprende anche la possibilità di accedere alla schermata del cameriere
           * - Inventario (menu || fastCash)
           * - Statistiche (fastCash)
           * Apps
           * - Contacts
           * - Spiagge.it PRO (almeno una licenza Spiagge.it associata)
           * Impostazioni
           * - Impostazioni
           * - Switch
           * - Aiuto
           */
          if(this.license.config.modules.fastCash.enabled) {
            if(this.accessControl && this.accessControl.fastCash) {
              views.items.push({
                name: "fastCash",
                external: false,
                icon: this.$anm22.icons.getWorldIcon('menuRegister'),
                iconHover: this.$anm22.icons.getWorldIcon('menuRegisterGrey'),
                description: this.$anm22.strLang(this.lang, 'Register', 'Cassa rapida'),
                href: "/fastCash",
                selectId: "fastCash"
              });
            }
            views.items.push({
              name: "orders",
              external: false,
              icon: this.$anm22.icons.getWorldIcon('menuTable'),
              iconHover: this.$anm22.icons.getWorldIcon('menuTableGreen'),
              description: this.$anm22.strLang(this.lang, 'Orders', 'Ordini'),
              href: '/orders',
              selectId: "orders"
            });
          }
          if(this.license.config.modules.tables.enabled) {
            views.items.push({
              name: "tables",
              external: false,
              icon: this.$anm22.icons.getWorldIcon('menuTables'),
              iconHover: this.$anm22.icons.getWorldIcon('menuTablesBrown'),
              description: this.$anm22.strLang(this.lang, 'Tables list', 'Lista tavoli'),
              href: '/tables',
              selectId: "tables"
            });
          }
          if((this.license.config.modules.menu.enabled || this.license.config.modules.fastCash.enabled) 
              && this.accessControl && this.accessControl.inventory) {
            views.items.push(
              {
                name: "warehouse",
                external: false,
                icon: this.$anm22.icons.getWorldIcon('menuWarehouse'),
                iconHover: this.$anm22.icons.getWorldIcon('menuWarehouseYellow'),
                description: this.$anm22.strLang(this.lang, 'Warehouse', 'Magazzino'),
                href: '/inventory',
                selectId: "inventory"
              }
            );
          }
          if(!this.isOffline && this.license.config.modules.fastCash.enabled && this.accessControl && this.accessControl.analytics) {
            views.items.push(
              {
                name: "analytics",
                external: false,
                icon: this.$anm22.icons.getWorldIcon('menuAnalytics'),
                iconHover: this.$anm22.icons.getWorldIcon('menuAnalyticsOrange'),
                description: this.$anm22.strLang(this.lang, 'Analytics', 'Statistiche'),
                href: '/analytics',
                selectId: "analytics"
              }
            );
          }
          if(this.hasYbLicenses) {
            apps.items.push(
              {
                name: "contacts",
                external: true,
                icon: this.$anm22.icons.getWorldIcon('menuContacts'),
                iconHover: this.$anm22.icons.getWorldIcon('menuContactsBlue'),
                description: 'Contacts',
                href: "https://pro.spiagge.it/customers/contacts",
                selectId: "contacts"
              }
            );
            apps.items.push(
              {
                name: "yourbeach",
                external: true,
                icon: this.$anm22.icons.getWorldIcon('menuBeach'),
                iconHover: this.$anm22.icons.getWorldIcon('menuBeachBlue'),
                description: 'Spiagge.it PRO',
                href: "https://pro.spiagge.it/",
                selectId: "yourbeach"
              },
            );
          } else {
            apps.items.push(
              {
                name: "contacts",
                external: true,
                icon: this.$anm22.icons.getWorldIcon('menuContacts'),
                iconHover: this.$anm22.icons.getWorldIcon('menuContactsBlue'),
                description: 'Contacts',
                href: "https://www.anm22.it/app/contacts-v/",
                selectId: "contacts"
              }
            );
          }
          return [views, apps, settings];
        } else {
          return [settings];
        }
      }
    },
    printers() {
      // Only if sequences are enabled
      if(this.license && this.license.config.modules.sequences.enabled && this.employment) {
        return this.$store.getters["foodPrinters/getByLicense"](
          this.license.id
        ).filter(p => p.printMode.list);
      } else {
        return [];
      }
    },
    spiaggeDomain() {
      return process.env.VUE_APP_SPIAGGE_DOMAIN;
    },
  },
  methods: {
    pageReload() {
      location.reload(); 
    },
    /* Script stampa comande */
    loadPrinters() {
      // Load printers
      this.printers.forEach(p => {
        window.createPrinter(p, process.env.VUE_APP_BACK_DOMAIN);
      });
    },
    enableAudioListener(e) {
      if(!this.audioEnabled){
        this.audioEnabled = true;
        document.removeEventListener('click', this.enableAudioListener);
      }
    },
    async sequencePrinterError(error, request) {
      console.log(request);
      const printerName = window['world_printer_' + request.idPrinter].name;
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Sequence printer error - " + printerName,
          "Errore stampante comande - " + printerName
        ),
        type: "alarm",
      });
      try {
        this.$http.post('printer-queue/put-back', {
          requestId: request.idPrintQueue
        });
      } catch(e) {
        console.log('Ristampa comanda ' + request.idPrintQueue + ' fallita');
      }
    },
    printRequests(requests) {
      const notifications = [];
      let playCustomerOrderSound = false;
      requests.forEach(request => {
        if(request.idPrinter != 0){
          // STAMPA CON STAMPANTE
          const articles = [];
          const articleLine = Object.assign(new WorldPrintArticle(), {
            description: "---------",
            quantity: 1,
            price: 0
          });
          articles.push(articleLine);
          articles.push(Object.assign(new WorldPrintArticle(), {
            description: 'ORDINE ' + String(request.orderId).substr(-5),
            quantity: 1,
            price: 0
          }));
          if (request.type && (request.type != '')) {
            articles.push(articleLine);
            articles.push(Object.assign(new WorldPrintArticle(), {
              description: request.type,
              quantity: 1,
              price: 0
            }));
          }
          articles.push(articleLine);
          articles.push(Object.assign(new WorldPrintArticle(), {
            description: 'CONSEGNA',
            quantity: 1,
            price: 0
          }));
          if (request.time && (request.time != '')) {
            // articles.push(articleLine);
            articles.push(Object.assign(new WorldPrintArticle(), {
              description: request.time,
              quantity: 1,
              price: 0
            }));
          }
          if (request.delivery && (request.delivery != '')) {
            // articles.push(articleLine);
            const deliveryLines = request.delivery.split('||');
            deliveryLines.forEach(dl => {
              articles.push(Object.assign(new WorldPrintArticle(), {
                description: dl,
                quantity: 1,
                price: 0
              }));
            });
          }
          request.dataToPrint.forEach(item => {
            articles.push(articleLine);
            articles.push(Object.assign(new WorldPrintArticle(), {
              description: this.$anm22.strLang(this.lang, 'Sequence ', 'Sequenza ') + item.sequence,
              quantity: 1,
              price: 0,
              vat: 0
            }));
            item.articles.forEach(elem => {
              articles.push(Object.assign(new WorldPrintArticle(), {
                description: elem.name,
                quantity: elem.qnt,
                price: 0,
                vat: 0
              }));
              if(elem.variations.length > 0){
                elem.variations.forEach(v => {
                  articles.push(Object.assign(new WorldPrintArticle(), {
                    description: "  " + v.sign + ' ' + this.$anm22.food_getVariationName(this.lang, v),
                    quantity: 1,
                    price: 0,
                    vat: 0
                  }));
                });
              }
            })
          });
          let world_print_content = new WorldPrintContent();
          world_print_content.printMode = 'list';
          world_print_content.articles = articles;
          if(typeof(request.notes) != 'undefined') {
            world_print_content.notes = request.notes;
          }
          world_print_content.timestamp = this.$moment().unix();
          const errorCallback = (error) => {
            this.sequencePrinterError(error, request);
          };
          // Chiamo il metodo print sulla stampante
          window["world_printer_" + request.idPrinter].print(world_print_content, undefined, errorCallback);
        } else {
          // STAMPA VIRTUALE - creazione di notifiche fittizie e suono
          const data = request.dataToShow;
          let label = "";
          label += data.type === 'new' 
              ? this.$anm22.strLang(this.lang, 'NEW', 'NUOVO') 
              : this.$anm22.strLang(this.lang, 'MODIFIED', 'MODIFICATO');
          label += ' ' + this.$anm22.strLang(this.lang, 'Order ', 'Ordine') + ' #' + data.orderId;
          const notification = {
            app: 7,
            img: "",
            read: 0,
            text: label,
            timestamp: request.time,
            title: "",
            url: process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL + "fastCash/"+data.orderId,
            user: ""
          };
          notifications.push(notification);
          if(data.customer) {
            playCustomerOrderSound = true;
          }
        }
      });
      if(notifications.length > 0) {
        this.$store.dispatch(
          "headbar/updateNotifications",
          notifications
        );
      }
      if(playCustomerOrderSound && this.audioEnabled && this.license.orderAlarm) {
        const sound = this.$refs['psNotificationSound'];
        sound.play().then(() => {}).catch(error => {console.log(error)});
        setTimeout(() => {
          sound.pause();
          sound.currentTime = 0;
        }, 4000);
      }
    },
    async checkRequests() {
      try {
        const response = await this.$http.get('printer-queue/check-requests');
        if(response.data && response.data.requests) {
          this.printRequests(response.data.requests);   
        }
      } catch(e) {
        // offline check - fd_print_queue dovrebbe contenere sempre meno tuple possibili per non rallentare Food
        const vlf = this.$vlf('fd_print_queue');
        const syncTable = this.$vlf('syncUpdates');
        const tuples = [], requests = [];
        await vlf.iterate((tuple, key, index) => {
          tuples.push(tuple);
        });
        tuples.filter(t => t.license === this.license.id && t.printed === 0)
          .sort((a,b) => a.time - b.time);
        tuples.forEach(async t => {
          if(t.idPrinter !== 0) {
            let notes = '', type = '', delivery = '', time = '', orderId = '', toPrint = [];
            Object.keys(t.printData).forEach(k => {
              switch(k) {
                case 'type':
                  type = t.printData[k];
                  break;
                case 'notes':
                  notes = t.printData[k];
                  break; 
                case 'delivery':
                  delivery = t.printData[k];
                  break;
                case 'time' :
                  time = t.printData[k];
                  break;
                case 'orderId':
                  orderId = t.printData[k];
                  break;
                default:
                  toPrint.push({
                    sequence: k,
                    articles: t.printData[k]
                  });
              }
            });
            requests.push({
              idPrinter: t.idPrinter,
              dataToPrint: toPrint,
              type,
              notes,
              delivery,
              time,
              orderId
            });
          } else {
            requests.push({
              idPrinter: t.idPrinter,
              dataToShow: t.printData,
              time: t.time
            });
          }
          // edit sync tuples
          const tupleIdStart = this.$anm22.MD5('FoodPrintQueue' + t.dbKey);
          const toUpdate = await syncTable.startsWith(tupleIdStart);
          toUpdate.forEach(update => {
            update.printed = true;
            syncTable.setItem(tupleIdStart+'@'+update.timestamp, update);
          });
        });
        // clear fd_print_queue
        vlf.clear();
        // print
        this.printRequests(requests);
      }
    },
    setWorkMenu() {
      this.$store.dispatch('menu/setCustomMode', {
        work: this.work,
        href: process.env.VUE_APP_FRONT_DOMAIN + process.env.BASE_URL
      });
    },
    async sync() {
      await this.$store.dispatch('offline/sync', {
        _vue: this,
        blocking: true,
        callback: async data => {
          if(this.$route.params.id) {
            const update = data.success.find(d => d.requestData.obj.id == this.$route.params.id);
            if(update) {
              this.$router.replace('/'+this.$route.name+'/'+update.responseData.id).catch(e => console.log(e));
            }
          }
        }
    });
    }
  },
  components: {
    WorldHeadbar,
    WorldMenu,
    PortalTarget,
    PinRequest,
    'vue-simple-spinner': Spinner,
  },
  async created() {
    // [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    /* Menu categories and elements */
    this.$store.dispatch('menu/setCategories', this.foodMenu);
    // /* Pulsante work custom */
    this.setWorkMenu();
    /* Sync */
    await this.sync();
    // Service worker updated event
    window.addEventListener('content-updated', () => {
      this.showRefreshPopup = true;;
    });
    // Load extensions
    if(process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PRODUCTION_MODE === 'test') {
      this.$anm22.loadScript(
        'chrome_extension_script_dev',
        "chrome-extension://jlgomipcfcagmlmdfknhohgbhiemgolp/enableChromeExt.js",
        () => {}
      );
    }
    this.$anm22.loadScript(
      'chrome_extension_script',
      "chrome-extension://deoglaoecglnimkaggbbgdkmhbdfgjid/enableChromeExt.js",
      () => {}
    );
    // // Service worker offline sync event
    // if('serviceWorker' in navigator){
    //   // Handler for messages coming from the service worker
    //   navigator.serviceWorker.addEventListener('message', event => {
    //     if(event.data.type === 'sync-data') {
    //       event.data.objs.forEach(d => {
    //         if(d.old.type === 'new' || d.old.type === 'edit'){
    //           this.$store.dispatch(d.table + '/update', {
    //             vlf: this.$vlf(d.table), objs: [d.obj]
    //           });
    //           if(d.old.type === 'new') {
    //             if(d.old.obj.idContactsContact === this.$store.getters['getSelectedContact']) {
    //               this.$store.dispatch('selectContact', d.obj.idContactsContact);
    //             }
    //             this.$store.dispatch(d.table + '/delete', {
    //               vlf: this.$vlf(d.table), obj: d.old.obj
    //             });
    //           }
    //         }
    //       });
    //     }
    //   });
    // }
  },
  mounted() {
    this.$anm22.eventBus.$on('execute-sync', this.sync);
    this.$store.dispatch('updateDimensions', { width: window.innerWidth, height: window.innerHeight });
    const ua = navigator.userAgent;
    const specs = {
      ua: ua,
      browser: /Edge\/\d+/.test(ua) ? 'ed' : /MSIE 9/.test(ua) ? 'ie9' : /MSIE 10/.test(ua) ? 'ie10' : /MSIE 11/.test(ua) ? 'ie11' : /MSIE\s\d/.test(ua) ? 'ie?' : /rv\:11/.test(ua) ? 'ie11' : /Firefox\W\d/.test(ua) ? 'ff' : /Chrome\W\d/.test(ua) ? 'gc' : /Chromium\W\d/.test(ua) ? 'oc' : /\bSafari\W\d/.test(ua) ? 'sa' : /\bOpera\W\d/.test(ua) ? 'op' : /\bOPR\W\d/i.test(ua) ? 'op' : typeof MSPointerEvent !== 'undefined' ? 'ie?' : '',
      os: /Windows NT 10/.test(ua) ? "win10" : /Windows NT 6\.0/.test(ua) ? "winvista" : /Windows NT 6\.1/.test(ua) ? "win7" : /Windows NT 6\.\d/.test(ua) ? "win8" : /Windows NT 5\.1/.test(ua) ? "winxp" : /Windows NT [1-5]\./.test(ua) ? "winnt" : /Mac/.test(ua) ? "mac" : /Linux/.test(ua) ? "linux" : /X11/.test(ua) ? "nix" : "",
      mobile: /IEMobile|Windows Phone|Lumia/i.test(ua) ? 'w' : /iPhone|iP[oa]d/.test(ua) ? 'i' : /Android/.test(ua) ? 'a' : /BlackBerry|PlayBook|BB10/.test(ua) ? 'b' : /Mobile Safari/.test(ua) ? 's' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 1 : 0,
      tablet: /Tablet|iPad/i.test(ua),
      touch: 'ontouchstart' in document.documentElement
    };
    this.$store.dispatch('updateDeviceSpecs', specs);
    this.$nextTick(() => {
      window.addEventListener(
        "resize", 
        _.debounce(() => {
          this.$store.dispatch('updateDimensions', { width: window.innerWidth, height: window.innerHeight });
        }, 500)
      );
    });
    document.addEventListener('click', this.enableAudioListener);
  },
  watch: {
    foodMenu(newVal, old) {
      this.$store.dispatch('menu/setCategories', this.foodMenu);
    },
    work(newVal, old) {
      this.setWorkMenu();
    },
    // Carico le stampanti solo se sono dipendente di questa licenza e le comande sono abilitate
    employment(newVal, old) {
      if(this.license.config.modules.sequences.enabled) {
        if(this.employment) {
          if(this.$anm22.getCookie('food_printer_master') !== '') {
            this.$store.dispatch('setIsPrinterMaster', true);
          }
          this.$store.dispatch("foodPrinters/load", this.$vlf('foodPrinters'));
          this.$http.get('printer-queue')
            .then(response => {
              this.$store.dispatch("foodPrinters/update", {
                vlf: this.$vlf("foodPrinters"),
                objs: response.data.printers
              })
              .then(() => {
                this.loadPrinters();
              })
            })
            .catch(e => console.log(e));
        }
      }
    },
    isPrinterMaster: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal){
          this.$anm22.eventBus.$emit('world-headbar-is-printer-master', true);
          // Se ho stampanti per comande inizializzate e sono impostato come dispositivo master
          this.printInterval = setInterval(() => {
            this.checkRequests();
          }, 10000);
        } else {
          this.$anm22.eventBus.$emit('world-headbar-is-printer-master', false);
          clearInterval(this.printInterval);
        }
      }
    }
  }
};
</script>


<style lang="scss">
iframe {
  min-height: 0 !important;
}
html {
  font-size: 62.5% !important;
}
.com-anm22-app-text-xs {
  font-size: 1rem !important;
}
.com-anm22-app-text-s {
  font-size: 1.2rem !important;
}
.com-anm22-app-text-m {
  font-size: 1.4rem !important;
}
.com-anm22-app-text-l {
  font-size: 1.6rem !important;
}
.com-anm22-app-text-xl {
  font-size: 1.8rem !important;
}
.com-anm22-app-text-xxl {
  font-size: 2rem !important;
}
</style>
